import { vendorDataReport } from './vendorDataReport';

export const report = { ...vendorDataReport };
